import ShopStorefrontPreview from "../components/ShopStorefrontPreview";

function ShopPreviewPage({ error, listings, mediaUrl, onAddItem, onBackToShops, onEditShop, onManageStock, onOpenListing, shop }) {
  return (
    <section className="main-panel">
      <div className="page-heading">
        <div><button className="text-button" onClick={onBackToShops} type="button">← Alle mini shops</button><span className="mini-label">Din offentlige butik</span><h1>{shop?.shop_name || "Min butik"}</h1><p>Her ser du butikken på samme måde som dine kunder.</p></div>
        <div className="shop-page-actions">
          <button className="primary-action" onClick={onAddItem} type="button">Tilføj vare</button>
          <button className="secondary-action" onClick={onEditShop} type="button">Rediger butik</button>
          <button className="secondary-action" onClick={onManageStock} type="button">Administrer lager</button>
        </div>
      </div>
      {error && <p className="status-line error">{error}</p>}
      <ShopStorefrontPreview listings={listings} mediaUrl={mediaUrl} onOpenListing={onOpenListing} shop={shop} />
    </section>
  );
}

export default ShopPreviewPage;
